export default __webpack_public_path__ + "static/media/score_bg_side.4e627348.jpg";